import { useEffect, useState } from 'react';
import { subscribeToAccessList, type AccessListEntry } from '@/services/access-list-service';

export const useAccessList = () => {
  const [entries, setEntries] = useState<AccessListEntry[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    return subscribeToAccessList(
      (data) => {
        setEntries([...data].sort((a, b) => a.value.localeCompare(b.value)));
        setIsLoading(false);
      },
      (subscribeError) => {
        setError(subscribeError.message);
        setIsLoading(false);
      }
    );
  }, []);

  return { entries, isLoading, error };
};
